import { render } from "./ElementShort.vue?vue&type=template&id=d255b41a&scoped=true"
import script from "./ElementShort.vue?vue&type=script&lang=js"
export * from "./ElementShort.vue?vue&type=script&lang=js"

import "./ElementShort.vue?vue&type=style&index=0&id=d255b41a&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d255b41a"]])

export default __exports__